import './publicPath';

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import 'utils/innerHeightVariable';
import { requestWakeLock, releaseWakeLock } from 'utils/wakeLock';

import App from 'components/App/App';
import { setTheme } from './utils/themeAssets';

require('styles/index.scss');

const savedTheme = localStorage.getItem('bingoTheme');
if (savedTheme) {
  setTheme(savedTheme);
} else if (window.bingoTheme) {
  setTheme(window.bingoTheme);
} else {
  setTheme('miljonlotteriet');
}

window.BingoClient = {
  init(data) {
    const container = document.getElementById(data.elementId || 'app');
    if (!container) {
      console.error(`Element with id ${data.elementId} not found`);
      return;
    }

    const root = createRoot(container);
    root.render(<App appData={data} />);

    // Prevent screen from sleeping using wake lock API
    requestWakeLock();

    // Release wake lock when the page is unloaded
    window.addEventListener('beforeunload', releaseWakeLock);

    this.data = data;
    this.root = root;

    return this;
  },

  updateBalance() {
    if (
      window.updateUserBalance &&
      typeof window.updateUserBalance === 'function'
    ) {
      window.updateUserBalance();
    }
    return true;
  },

  setAudio(activated) {
    if (window.setGlobalAudio && typeof window.setGlobalAudio === 'function') {
      window.setGlobalAudio(activated);
    }
    return true;
  },
};

export default window.BingoClient;
